module.exports = __webpack_public_path__ + "static/assets/f3f62a2859e4f5388a60c2c440771ec0.png";